<template>
  <v-main>
    <v-container
      fluid
      style="height: 100vh; width: 100vw;"
      class="justify-center d-flex flex-column align-center"
    >
      <p class="mt-16 text-center text-h2 font-weight-semibold primary--text">
        You are not alone!
      </p>
      <p class="mt-6 text-center text-body-1 font-weight-medium">
        If you need someone to talk to, do not hesitate to call!
      </p>
      <p class="text-center text-body-1 font-weight-medium mt-n4">
        Here are some of the local mental health support hotlines you may
        contact:
      </p>

      <section class="mt-16">
        <v-row align="center" justify="center" wrap>
          <v-col
            sm="12"
            md="2"
            lg="2"
            xl="2"
            v-for="contact of contacts"
            :key="contact.name"
          >
            <Contact
              :name="contact.name"
              :icon="contact.icon"
              :tel="contact.tel"
            />
          </v-col>
        </v-row>
      </section>
    </v-container>
    <footer class="mt-16" style="width: 100%; position: absolute; top: 100vh">
      <Footer />
    </footer>
  </v-main>
</template>

<script>
import Footer from '@/components/Footer.vue'
import Contact from '@/components/Support/Contact.vue'
export default {
  name: 'Support',
  components: { Footer, Contact },
  data: () => ({
    contacts: [
      {
        name: 'Crisis Hotlines',
        icon:
          'https://thumbs.dreamstime.com/b/vector-illustration-hour-service-sign-icon-isolated-white-background-hour-call-155498678.jpg',
        tel: [
          '893-7606',
          '893-7603',
          '0917-800-1123',
          '2-893-7603',
          '0922-893-8944'
        ]
      },
      {
        name: 'National Center for Mental Health',
        icon:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f7/National_Center_for_Mental_Health_%28NCMH%29.svg/1200px-National_Center_for_Mental_Health_%28NCMH%29.svg.png',
        tel: ['0917-899-8727', '(02) 7989-8727']
      },
      {
        name: 'Philippine Mental Health Association, Inc.',
        icon:
          'https://res.cloudinary.com/dywkbcfp5/image/upload/w_200,h_200,bo_2px_solid_white,f_auto/v1603278414/bjeyieb4ovoopoazzfyc.png',
        tel: ['0995-093-2679', '0918-402-9832']
      },
      {
        name: 'Hopeline',
        icon:
          'https://scontent.fcrk1-2.fna.fbcdn.net/v/t1.18169-9/22366808_313694799098364_2003870568265858687_n.jpg?_nc_cat=110&ccb=1-5&_nc_sid=09cbfe&_nc_eui2=AeFpaOUf9Mi_VxVILxLCkVB9s5vL_Z8fH3Ozm8v9nx8fcwu8WhP-EYZZ7_6PplsHTFnt3JkAE-hmYsLX2lEj9sbb&_nc_ohc=TTTeKdcF3JYAX8SnX1p&_nc_ht=scontent.fcrk1-2.fna&oh=00_AT8FDQ1rt9ACCfskUQPTZcy0BSKhFef-tEOxNZNnG7G1EQ&oe=6243A531',
        tel: [
          '0917-558-4673 [Globe]',
          '0918-873-4673 [Smart]',
          '02-88044673 [PLDT]',
          '2919 [toll-free for Globe and TM]'
        ]
      },
      {
        name: 'Mental Health Psychosocial Support (MHPSS)',
        icon:
          'https://thumbs.dreamstime.com/b/psychosocial-support-concept-icon-psychosocial-support-concept-icon-impact-psychological-state-work-idea-thin-line-210006325.jpg',
        tel: ['0956-8161-06 [Globe / TM]', '2968-4222-875 [Smart]']
      }
    ]
  })
}
</script>

<style></style>
